var map = {
	"./c.svg": 313,
	"./dev.png": 644,
	"./git.svg": 33,
	"./gmail.svg": 716,
	"./java.svg": 482,
	"./javascript.svg": 254,
	"./link.svg": 219,
	"./php.svg": 613,
	"./python.svg": 730,
	"./twt.svg": 8,
	"./typscript.svg": 924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;